import { getGraphqlClient } from "@/api/graphql/client.ts";

import { toggleFormDataRuleGroupMutation } from "./mutations.ts";

export const toggleFormDataRuleGroup = (id: string) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(toggleFormDataRuleGroupMutation, { id });
};
